<template>
  <div>
    <ul class="flex flex-wrap gap-2" id="myTab" role="tablist">
      <li
        class=""
        role="presentation"
        v-for="(year, index) in agendas"
        :key="index"
      >
        <button
          type="button"
          class="block px-4 py-3 text-default-500 hover:text-default-600"
          :class="{ 'bg-white rounded-t-lg': year.year === currentYear }"
          v-on:click="toogleYear(year.year)"
        >
          {{ year.year }}
        </button>
      </li>
    </ul>
    <div class="p-4 bg-white rounded-b-lg shadow" id="myTabContent">
      <div
        v-for="(year, index) in agendas"
        :key="index"
        class="tab-pane fade"
        :class="{ 'show active': year.year === currentYear }"
        :id="'nav-' + year.year"
        role="tabpanel"
        :aria-labelledby="'nav-' + year.year + '-tab'"
      >
        <div class="card">
          <div class="card-body">
            <list-agenda :months="year" v-if="year.year === currentYear" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Semed from "./../../api/Semed";
import ListAgenda from "./listAgenda.vue";

export default {
  name: "indexAgenda",
  props: ["path"],
  data() {
    return {
      agendas: null,
      currentYear: new Date().getFullYear(),
    };
  },
  created() {
    Semed.get(this.path).then((response) => {
      this.agendas = response.data;
    });
  },
  methods: {
    toogleYear(year) {
      this.currentYear = year;
    },
  },
  components: { ListAgenda },
};
</script>

<style scoped></style>
